export default __webpack_public_path__ + "static/hitech-iot-ind-equip-7471e0cc2c5dc4fa31a26761be6c67dc.png";